import { Box, Stack, Typography } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import { ReactNode } from "react";
import { getResourceIcon } from "@/utils/icons";
import { formatToTitleCase } from "@/utils/formatters/stringFormatters";

interface ListEmptyStateProps {
  /** Resource name — auto-resolves icon and message when provided */
  resource?: string;
  /** Override icon (takes precedence over resource) */
  icon?: SvgIconComponent;
  /** Override icon size in px (default: 40) */
  iconSize?: number;
  /** Override message (takes precedence over resource) */
  message?: string;
  subtitle?: string;
  action?: ReactNode;
}

export const ListEmptyState = ({ resource, icon, iconSize = 40, message, subtitle, action }: ListEmptyStateProps) => {
  const ResolvedIcon = icon ?? (resource ? getResourceIcon(resource) : undefined);
  const resolvedMessage =
    message ?? (resource ? `No ${formatToTitleCase(resource).toLowerCase()} found` : "No records found");

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
      <Stack alignItems="center" spacing={1}>
        {ResolvedIcon && <ResolvedIcon sx={{ fontSize: iconSize, color: "text.disabled", mb: 0.5 }} />}
        <Typography variant="body1" color="text.secondary" fontWeight={500}>
          {resolvedMessage}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.disabled">
            {subtitle}
          </Typography>
        )}
        {action && <Box sx={{ mt: 1.5 }}>{action}</Box>}
      </Stack>
    </Box>
  );
};
